const LanguageMap = {
  nl: 'Nederlands',
  en: 'English',
  de: 'Deutsch',
}

export default LanguageMap;